import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: 'confirm-dialog.component.html',
    styleUrls: ['confirm-dialog.component.scss']
})
export class ConfirmationDialogComponent {
    dataObj = {
        closeModal: true
    };
    constructor(
        public dialogConfimRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.data = data;
    }

    onCancelConfirm(): void {
        this.dialogConfimRef.close();
    }
}
